import { createStyles } from '@mantine/core'

export default createStyles(() => ({
  maskModal: {
    zIndex: 9320483043921,
    fontFamily: 'Arial, sans-serif',
  },
  banner: {
    maxWidth: '80vw',
  },
  slide: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column',
  },
  asianTextBlock: {
    whiteSpace: 'nowrap',
  },
  fadeInBackToTop: {
    display: 'block',
  },
}))
